<div class="row">
    <div class="col-12 box" [ngSwitch]="event">
        <div class="col-12 box-title" *ngSwitchCase="'signing_complete'">
            Upload your Driver’s License.
        </div>
        <div class="col-12 box-title" *ngSwitchCase="'viewing_complete'">
            You’re all set!
        </div>
        <div class="col-12 box-title" *ngSwitchDefault>
            Something has happened.
        </div>
    </div>
    <div class="col-12 box-list" [ngSwitch]="event">
        <h2 *ngSwitchCase="'signing_complete'">
            Next Steps:
        </h2>
        <h2 *ngSwitchCase="'viewing_complete'">
            It’s that easy with Clicklease!
        </h2>

        <h2 *ngSwitchCase="'cancel'">
            Sorry, the recipient decides to finish later.
        </h2>
        <h2 *ngSwitchCase="'decline'">
            Sorry, the recipient has declined the signature.
        </h2>
        <h2 *ngSwitchCase="'exception'">
            Sorry, a processing error occurs during the signing session.
        </h2>
        <h2 *ngSwitchCase="'fax_pending'">
            Sorry, the recipient chose to print, sign and fax back.
        </h2>
        <h2 *ngSwitchCase="'id_check_failed'">
            Sorry, the authentication that was added to the document has failed.
        </h2>
        <h2 *ngSwitchCase="'session_timeout'">
            Sorry, the signing session is over.
        </h2>
        <h2 *ngSwitchCase="'ttl_expired'">
            Sorry, the token was not used within the timeout period or the token was already accessed.
        </h2>
        <h3 *ngSwitchCase="'viewing_complete'">
            Check your email for a copy of the documents.
        </h3>
        <ol *ngSwitchCase="'signing_complete'">
            <li>
                We sent a text message to directing you to take a picture of the front and back of your driver’s
                license. This is required in order to complete the transaction.
            </li>
            <li>
                If you did not receive the text message please chat with us
                <span style="text-decoration: underline; color: #276dac;">
                    <a href="https://home-c35.nice-incontact.com/incontact/chatclient/chatclient.aspx?poc=97e77c7f-d8a6-4af0-95eb-f8975110c562&bu=4599274"
                        target="_blank">here</a>
                </span>.
            </li>
            <li>
                If the store doesn't contact you first, contact your sales associate to schedule delivery or pickup.
            </li>
        </ol>
    </div>
</div>